import React, { useState, useRef } from 'react';
import { Grid, Theme, Dialog } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { PlayCircleFilled } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';

export interface VideoProps {
  thumbnail: string;
  videoUrl: string;
  width: string | number;
  height: string | number;
}

const useStyles = makeStyles<Theme, VideoProps>((theme) => ({
  root: {},
  paper: {
    backgroundColor: 'transparent',
    // boxShadow: theme.shadows[3],
  },
  videoBtnWrapper: {
    appearance: 'none',
    backgroundColor: 'transparent',
    padding: 0,
    border: 'none',
    width: '100%',
    maxWidth: ({ width }) => width,
    height: ({ height }) => height,
    cursor: 'pointer',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'black',
    borderRadius: '8px',
    position: 'relative',
  },
  playBtnWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // backgroundColor: 'white',
    lineHeight: 0,
  },
  videoDialogFrame: {
    height: 500,
    [theme.breakpoints.down('md')]: {
      height: 320,
    },
  },
}));

export const VideoComponent = (props: VideoProps) => {
  const classes = useStyles(props);

  const videoDialog = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    // videoDialog.current?.click();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <button type="button" className={classes.videoBtnWrapper} onClick={handleOpen}>
        <div style={{ backgroundImage: `url(${props.thumbnail})` }} className={classes.thumbnail}>
          <div className={classes.playBtnWrapper}>
            <svg
              width="69"
              height="69"
              viewBox="0 0 69 69"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34.3462 0.94458C15.7034 0.94458 0.573059 16.0749 0.573059 34.7177C0.573059 53.3605 15.7034 68.4908 34.3462 68.4908C52.989 68.4908 68.1193 53.3605 68.1193 34.7177C68.1193 16.0749 52.989 0.94458 34.3462 0.94458ZM27.5916 49.9156V19.5198L47.8554 34.7177L27.5916 49.9156Z"
                fill="#252525"
              />
              <path
                d="M27.5915 48.8803V20.5198C27.5915 19.9656 28.222 19.6473 28.668 19.9762L47.4722 33.8482C47.8334 34.1147 47.8391 34.6529 47.4835 34.9268L28.6793 49.4153C28.2351 49.7575 27.5915 49.4409 27.5915 48.8803Z"
                fill="white"
                stroke="white"
                strokeWidth="0.675463"
              />
            </svg>
          </div>
        </div>
      </button>

      <Dialog
        ref={videoDialog}
        fullWidth
        maxWidth="md"
        open={open}
        // onEnter={() => setTimeout(() => console.log(videoDialog.current), 1000)}
        classes={{
          paper: classes.paper,
        }}
        onClose={handleClose}
      >
        <iframe
          className={classes.videoDialogFrame}
          width="100%"
          src={props.videoUrl}
          title="Quillbot video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Dialog>
    </div>
  );
};
